<h1 mat-dialog-title>
    Charger un modèle
</h1>

<mat-dialog-content>
    <syn-message-box
        color="warning_outlined"
        leftIcon="alert-outline"
        [noMarginTop]="true"
    >Charger un modèle écrasera vos modifications
    </syn-message-box>

    <syn-picker
        (change)="slas = $event?.sla"
        placeholder="Modèle"
        [contentLoader]="slaPickerContentLoader"
        [content]="slaPicker$"
        [itemTemplate]="slaItemTemplate"
        [strictSearch]="false"
        class="picker"
        fxFlexFill />

    @if (loading) {
        <div class="progress-spinner">
            <mat-progress-spinner mode="indeterminate" [diameter]="40" />
        </div>
    } @else {
        <div class="list-gti-gtr">
            <syn-project-wizard-sla-gti-gtr-read *ngFor="let sla of slas"
                class="gti-gtr"
                [sla]="sla" />
        </div>
    }
</mat-dialog-content>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end" fxLayoutGap="5px">
    <button mat-button (click)="cancel()">Annuler</button>
    <button mat-button (click)="load()" [disabled]="loading || !slas" color="primary">Charger</button>
</div>

<ng-template #slaItemTemplate
             let-name="content.name"
             let-id="content.id">
    <div fxLayout="row"
         fxLayoutAlign="space-between center"
         [matTooltip]="id">
        <span class="template_header">{{ name }}</span>
    </div>
</ng-template>
